import { Suspense } from 'react';
import { ErrorBoundary } from '@sentry/react';
import { Box, Heading } from '@simplywallst/ui-core';
import { useFlag } from '@/features/unleash';
import { Skeleton } from './components/Skeleton';
import { Screeners } from './components/Screeners';
import { ErrorDisplay } from './components/ErrorDisplay';

const Content = () => (
  <ErrorBoundary fallback={ErrorDisplay}>
    <Suspense fallback={<Skeleton />}>
      <Screeners />
    </Suspense>
  </ErrorBoundary>
);

export const MyScreenersDesktop = () => {
  const myScreenersWidgetFlag = useFlag({ name: 'mono-my-screeners-widget' });
  if (myScreenersWidgetFlag.variant.name !== 'variant') return;

  return (
    <Box as="section" marginBottom="x2" data-cy-id="my-screeners-desktop">
      <Box marginTop="x1" marginBottom="x2">
        <Heading as="h1" typography="xSmall" color="whiteRGBA" opacity={0.7}>
          My Screeners
        </Heading>
      </Box>
      <Content />
    </Box>
  );
};

export const MyScreenersMobile = () => {
  const myScreenersWidgetFlag = useFlag({ name: 'mono-my-screeners-widget' });
  if (myScreenersWidgetFlag.variant.name !== 'variant') return;

  return (
    <Box as="section" data-cy-id="my-screeners-mobile">
      <Content />
    </Box>
  );
};
